/** Maps item ids → their sprite-sheet icon URLs (served from public/sprites). */
const BASE = import.meta.env.BASE_URL;

export const ITEM_ICON: Record<string, string> = {
  moonCore: `${BASE}sprites/icon_moonCore.png`,
  energyCore: `${BASE}sprites/icon_energyCore.png`,
  darkMatter: `${BASE}sprites/icon_darkMatter.png`,
  warpFuel: `${BASE}sprites/icon_warpFuel.png`,
  // Eater of Worlds parts — use the boss's own sprites as their inventory icons.
  eowHead: `${BASE}sprites/EOW_Head.png`,
  eowBody: `${BASE}sprites/EOW_Body.png`,
  eowTail: `${BASE}sprites/EOW_Tail.png`,
  // eowEnergyCore icon is TBD — falls back to its emoji until the art lands.
};

export function itemIcon(id: string): string | undefined {
  return ITEM_ICON[id];
}

/** Display names, shared by the inventory + the boss-loot popup. */
export const ITEM_NAME: Record<string, string> = {
  moonCore: "Moon Core",
  energyCore: "Energy Core",
  darkMatter: "Dark Matter",
  warpFuel: "Warp Drive Fuel",
  eowHead: "Eater of Worlds — Head",
  eowBody: "Eater of Worlds — Segment",
  eowTail: "Eater of Worlds — Tail",
  eowEnergyCore: "Eater's Core",
};

export function itemName(id: string): string {
  return ITEM_NAME[id] ?? id;
}
